import * as tslib_1 from "tslib";
import selectHideSenderImageOption from '../actions/selectHideSenderImageOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
// import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
var SenderImageFull = /** @class */ (function (_super) {
    tslib_1.__extends(SenderImageFull, _super);
    function SenderImageFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHideSenderImageChange = function (ev, option) {
            selectHideSenderImageOption(option.key === 'true');
        };
        return _this;
    }
    SenderImageFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var showSenderImageInListView = getFallbackValueIfNull(optionStore.showSenderImageInListView, !getIsBitSet(8 /* HideSenderImage */));
        return (React.createElement(ChoiceGroup, { selectedKey: "" + showSenderImageInListView, options: [
                {
                    key: 'true',
                    text: strings.options_messageList_showSenderImage,
                },
                {
                    key: 'false',
                    text: strings.options_messageList_hideSenderImage,
                },
            ], onChange: this.onHideSenderImageChange, label: strings.options_messageList_senderImageLabel }));
    };
    SenderImageFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
        })
    ], SenderImageFull);
    return SenderImageFull;
}(React.Component));
export default SenderImageFull;
//# sourceMappingURL=SenderImageFull.js.map